module.exports = __webpack_public_path__ + "img/document-icon.b39607d5.svg";